import { render, staticRenderFns } from "./historicalStatistics.vue?vue&type=template&id=6f282dbe&scoped=true&"
import script from "./historicalStatistics.vue?vue&type=script&lang=ts&"
export * from "./historicalStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./historicalStatistics.vue?vue&type=style&index=0&id=6f282dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f282dbe",
  null
  
)

export default component.exports